export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/choose-company',
    name: 'choose-company',
    component: () => import('@/views/auth/ChooseCompany.vue'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/switch-company',
    name: 'switch-company',
    component: () => import('@/views/auth/ChooseCompany.vue'),
    meta: {
      layout: 'full',
      requiresAuth: true,
    },
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('@/views/auth/ResetPassword.vue'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
    },
  },
]
